import React,{useEffect, useState, useRef} from 'react'
import Layout from "../components/Layout";
import emailjs, { init } from '@emailjs/browser';
import validator from 'validator'
import Swal from 'sweetalert2'

// Initialize EmailJS
init("user_Lwk8aWjOdWtB0gfz4M9Oi");
function Contact() {
  useEffect(() => {
    window.scrollTo(0,0)
      }, [])
  const form = useRef();

  const[f, setF] = useState({
    'name': '',
    'email': '',
    'message': '',
  })

  function handleChange(e){
    setF({...f,
      [e.target.name]: e.target.value
    });
  }
  function CustomAlert(mes) {Swal.fire({
    title: mes,
    icon: 'error',
    background: 'black',
    color: 'white',
    showClass: {
      popup: 'animate__animated animate__rollIn'
    },
    hideClass: {
      popup: 'animate__animated animate__rollOut'
    }
  })}
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })
  function email (e)  {
    e.preventDefault()
    if (validator.isEmail(f.email) ===false){
      return CustomAlert('Please Enter Valid Email')
    }
    if(f.name.length < 3){
      return CustomAlert('Please Enter Valid Name')
    }
    if (f.message === ''){
      return CustomAlert('Please Enter Valid Message')
    }
    emailjs.sendForm('service_9j8ba9b', 'template_16nozbf', form.current, 'user_Lwk8aWjOdWtB0gfz4M9Oi')
      .then((result) => {
           Toast.fire({
            icon: 'success',
            background: 'black',
    color: 'white',
            title: 'your message has been sent'});
            return setF({
              name: '',
              email: '',
              message: '',
            })});
      
  };

  return (
    <Layout>
      <div >
    <div className="h-screen   text-center  " data-aos='zoom-in-up'>
    <lottie-player
                src="https://assets7.lottiefiles.com/private_files/lf30_egxsy0o3.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
    </div>
            <h1 data-aos='fade-up' className="text-5xl font-semibold text-center relative md:bottom-[9rem] xl:bottom-[16rem] xl:p-10 xl:text-6xl lg:bottom-[13rem] lg:p-10 lg:text-5xl bottom-[5rem] w-fit p-3 mx-auto text-white  md:text-3xl animate-pulse border bg-fuchsia-700 rounded-full ">Contact Me Below</h1>
    </div>
    <form ref={form} onSubmit={email} data-aos="zoom-in" className="  flex justify-center ">
      <div  className="md:w-full xl:w-3/4 w-1/2 relative md:bottom-[2rem] bottom-[3rem] xl:bottom-[7rem] border-t border-white border-2 rounded-2xl   p-3 shadow-2xl shadow-blue-700">
        
        <input onChange={handleChange} name='name' type="text" value={f.name} placeholder='What Is Your Name?' className="w-full border-2 border-fuchsia-700 rounded p-1 shadow-lg mt-5" />
        <input onChange={handleChange} name='email' type="text" valie={f.email} placeholder='What Is Your Email?' className="w-full border-2 border-fuchsia-700 rounded p-1 shadow-lg mt-5" />
        <textarea onChange={handleChange} name='message' type="text" value={f.message} placeholder='Remember There Is NO Such Thing As A Stupid Question 😇' className=" h-[5rem] w-full border-2 border-fuchsia-700 rounded p-1 shadow-lg mt-5" />
        <div   className="text-center">
        <button type='submit' className='bg-fuchsia-700 mt-2 hover:bg-e rounded text-white px-5 py-1 text-center' >SUBMIT</button>
        </div>
      </div>

    </form>
  </Layout>
  )
}

export default Contact